import { Component, OnInit, OnDestroy } from '@angular/core';
import { SharedService } from "../../services/shared.service";
import { ApiService } from "../../services/api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/takeUntil";
import { AuthenticationService } from "../../services/authentication.service";
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-product-tracking-component',
  templateUrl: './product-tracking-component.component.html',
  styleUrls: ['./product-tracking-component.component.css']
})
export class ProductTrackingComponentComponent implements OnInit  {
  destroy$: Subject<boolean> = new Subject<boolean>();
  err = { show: false, title: "", message: "" };
  hiddenSpinner = true;
  keypairComplete = false;
  keypairExists = false;
  keypairResults;
  currentUserID = this.auth.getUserDetails()._id;
  keyModel = {owner_id: this.currentUserID};
 
  constructor(
    private shared: SharedService,
    private api: ApiService,
    public auth: AuthenticationService,
    private httpClient: HttpClient,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.api.postCheckKeypair(this.keyModel).subscribe(
      res => {
        if (res.count == 1){
          this.keypairExists = true;
        }
      },
      err => {
        console.log(err);
      })
    }
    
  
  

  createKeypair() {
    console.log(this.keyModel);
    this.api.postCreateKeypair(this.keyModel)
        .subscribe(
          res => {
            console.log(res);
            // this.keypairComplete = true;
            this.keypairResults = res;
            if (this.keypairResults.count == 0) {
              this.keypairComplete = true;
            } else{
              // this.keypairExists = true
              alert("Keypair already exists");
            }
          })
  };



  selectRegisterProduct() {
    this.router.navigateByUrl('tracking/register')
    
  }

  selectSeeAssets() {
    this.router.navigateByUrl('tracking/seeproducts')
  }

  next(){
    this.router.navigateByUrl('tracking')
  }


  }
